var map = {
	"./client1.png": 1270,
	"./client10.png": 1271,
	"./client11.png": 1272,
	"./client12.png": 1273,
	"./client13.png": 1274,
	"./client14.png": 1275,
	"./client15.png": 1276,
	"./client16.png": 1277,
	"./client17.png": 1278,
	"./client18.png": 1279,
	"./client19.png": 1280,
	"./client2.png": 1281,
	"./client20.png": 1282,
	"./client21.png": 1283,
	"./client22.png": 1284,
	"./client23.png": 1285,
	"./client24.png": 1286,
	"./client25.png": 1287,
	"./client26.png": 1288,
	"./client27.png": 1289,
	"./client28.png": 1290,
	"./client3.png": 1291,
	"./client4.png": 1292,
	"./client5.png": 1293,
	"./client6.png": 1294,
	"./client7.png": 1295,
	"./client8.png": 1296,
	"./client9.png": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1269;